import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Favorite, { FAVORITE_TYPE_LINK } from 'components/Favorite';

const FavoriteLink = props => {
  const { favoriteData, favoritesManager, theme, withLabel } = props;

  if (!get(favoriteData, 'favoritableItems')) return null;
  const { showType } = favoriteData;
  const favorites = get(favoritesManager, 'favorites');
  return (
    <Favorite
      theme={theme}
      manager={favoritesManager}
      favorites={favorites}
      data={favoriteData}
      type={FAVORITE_TYPE_LINK}
      defaultText={withLabel ? `Favorite ${showType}` : ''}
      favoritedText={withLabel ? `Unfavorite ${showType}` : ''}
      stopNavigationOnClick
    />
  );
};

export default FavoriteLink;

FavoriteLink.defaultProps = {
  favoriteData: null,
  favoritesManager: null,
  withLabel: false,
};

FavoriteLink.propTypes = {
  favoriteData: PropTypes.shape({}),
  favoritesManager: PropTypes.shape({}),
  theme: PropTypes.shape({}).isRequired,
  withLabel: PropTypes.bool,
};
